/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteKpiFarmSetting$Params {
  kpiFarmSettingId: number;
}

export function deleteKpiFarmSetting(http: HttpClient, rootUrl: string, params: DeleteKpiFarmSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteKpiFarmSetting.PATH, 'delete');
  if (params) {
    rb.path('kpiFarmSettingId', params.kpiFarmSettingId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteKpiFarmSetting.PATH = '/api/kpisettings/{kpiFarmSettingId}';
